import ClientPortalUsers from './ClientPortalUsers';

export default ClientPortalUsers;
